//
//
//
//
//
//

export default {
  mounted () {
    this.$nextTick(() => {
      this.$parent.destroy()
      this.$parent.init()
      this.$parent.start()
    })
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/marquee/marquee-item.vue